/**
 * Hit again › Texts lives with Hit again (user, 21/10/2026: "why it doesn't
 * have the same params from the master … when I've said override all
 * containers for the hit again"). The choice was kept in the Texts
 * section's policy, so a container that keeps its own prompt kept its own
 * hit-again texts too, and pushing Verdicts did not carry it. It is now a
 * Verdicts value (the verdict row's hitTextsJson): null = the texts of the
 * drop that hit, a mix = new texts. Every reader lays it over the Texts
 * policy with these two functions, so the engine, the fill and both editor
 * rows see one value.
 * For Media Devoted | Created By Ciro Autiero
 */
import type { DropGenTextMix, DropGenTextPolicy } from "../text-policy";
import { parseMix } from "./policy-parse";

/** The Texts policy without the hit-again line (it belongs to Hit again). */
export function withoutHitTexts(policy: DropGenTextPolicy | null | undefined): DropGenTextPolicy {
  const rest: DropGenTextPolicy = { ...(policy ?? {}) };
  delete rest.HIT_AGAIN;
  return rest;
}

/** The Texts policy with Hit again's own choice on it (stored JSON or a mix; null = the texts of the drop that hit). */
export function withHitTexts(policy: DropGenTextPolicy | null | undefined, hitTexts: unknown): DropGenTextPolicy {
  const rest = withoutHitTexts(policy);
  const mix = parseMix(hitTexts);
  return mix ? { ...rest, HIT_AGAIN: mix } : rest;
}

/** Stored hitTextsJson → the mix, or null (the texts of the drop that hit). */
export const parseHitTexts = (stored: unknown): DropGenTextMix | null => parseMix(stored);
